// extracted by mini-css-extract-plugin
export var cartContainer = "_o5-4";
export var gray = "_o5-1";
export var itemContainer = "_o5-2";
export var itemDetails = "_o5-3";
export var strong = "_o5-0";